<template>
    <el-row :gutter="30"  class="mw-100 manage-art" >
        
        <el-col :lg="24" :xs="24">
            <el-card v-if="currentArtData?.imageURL?.length">
                
                <el-form 
                    class="text-center font-24" 
                    ref="addArtRef"
                    :model="currentArtData"
                    :rules="currentArtDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="18" :xs="24">
                            <el-form-item class="w-100">
                                <el-button type="primary" @click="manageArt('addArtRef')" class="text-cap mr-20" v-if="!artLoading">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                                <el-divider></el-divider>
                                <el-upload
                                    ref="imageBase64"
                                    action="#"
                                    :auto-upload="false"
                                    :on-change="onUploadArt"
                                    
                                    :on-remove="handleRemoveArt"
                                    accept="art/mp4"
                                    class="font-14"
                                >
                                    <font-awesome-icon :icon="['fas', 'upload']" style="width:20px" class="mr-10" />
                                    <span class="text-12">Upload Art</span>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                       
                        <el-col :lg="12" :xs="24" v-if="currentArtData.imageURL.length">
                            <el-form-item  label="art" prop="imageBase64">
                                
                                <el-image 
                                    style="width: 250px; height: 250px;margin-right:20px" 
                                    :src="isAddArt ? currentArtData.imageURL :  $getImage(currentArtData.imageURL) || ''" 
                                    fit="cover"
                                    :zoom-rate="1.2"
                                    :preview-src-list="[isAddArt ? currentArtData.imageURL : $getImage(currentArtData.imageURL)]"
                                    :preview-teleported="true"
                                >
                                    <template #error>
                                        <div class="image-slot">
                                            <font-awesome-icon :icon="['fas', 'image']" />
                                        </div>
                                    </template>
                                </el-image>
                            </el-form-item>
                        </el-col>
                      
                        
                    </el-row>
                </el-form>
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
export default {
    data(){
        return {
            isAddArt:false,
            poster:0.5,
            artLoading:false,
            currentArtData:{},
            copyArtData:{},
            currentArtDataRules:{
                imageBase64:{
                    message:'required field',
                    trigger:'blur',
                    required:true
                },
            },
        }
    },
    mounted(){
        this.getCareersArt()
    },
    methods:{
        async getCareersArt(){
            const response = await this.$store.dispatch('getCareersArt')
            if(response.data.status == 1){
                this.currentArtData = response.data.data[0];
                this.currentArtData.imageBase64 = '';
                this.copyArtData = JSON.parse(JSON.stringify(this.currentArtData));
                
            }
        },
        
      
        async onUploadArt(file){
            this.artLoading = true;
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                // reader.readAsDataURL(file);
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.replace(/^data:image.+;base64,/,''));
                
                reader.onerror = reject;
                
            });
            if (this.currentArtData.imageBase64.length){
                this.$refs['imageBase64'].clearFiles()
            }
            this.currentArtData.imageBase64 =  await toBase64(file.raw);
            this.currentArtData.imageURL =  URL.createObjectURL(file.raw);
            this.artLoading = false;
            


        },
        onUploadArtOld(file){
            
            // if((file.size / Math.pow(1024, 2)).toFixed(2) * 1 > 5){
            //     this.$notify({
            //         title:'File Size Exceded',
            //         message:'the file uplaoded should be less than 5 MB',
            //         type:'warning',
            //     });
            //     this.$refs['imageBase64'].clearFiles()
            // }else{  
            const FR = new FileReader();
            let module = this;
            FR.addEventListener("load", function(evt) {
                module.currentArtData.imageBase64 = evt.target.result;
            }); 
            this.currentArtData.imageURL = '';
            setTimeout(() => {
                this.currentArtData.imageURL =  URL.createObjectURL(file.raw);
                this.poster = 0.3;
                this.artLoading = false;
            }, 1000);
            if (this.currentArtData.imageBase64.length){
                this.$refs['imageBase64'].clearFiles()
            }
            FR.readAsDataURL(file.raw);
            // }
        },    
        handleRemoveArt(){
            this.currentArtData.imageURL = '';
            setTimeout(() => {
                this.currentArtData.imageURL = this.copyArtData.imageURL
            }, 1000);
            
        },
        async manageArt(formName){
            
            const element = this.$refs[formName];
            element.validate(async (valid) => {
                if (!valid) {
                    this.$notify({
                        message:`the art is mandatory , you didn't change it yet `,
                        type:'warning',
                        duration:5000,
                        showClose: true,
                    });
                }
            }).then(data =>{
                if (data){
                    this.manageArtAfterValidate()
                }
            })  
           
            
            
            
            
            
        },
        async manageArtAfterValidate(){
            
            const response = await this.$store.dispatch('updateCareersArt',this.currentArtData);
            if (response.data?.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
            }
        }, 
    }
}
</script>